import React, { useState } from 'react';
import './BoutiqueFlashCards.css';

const BoutiqueFlashCards = ({ onComplete }) => {
  const [currentCard, setCurrentCard] = useState(0);

  const flashCards = [
    {
      title: "Welcome to My Boutique Page! 👔",
      description: "Create your personal fashion feed where YOU are the model for every outfit.",
      icon: "✨"
    },
    {
      title: "Personalized Just For You",
      description: "Select your favorite brands and styles. We'll automatically generate try-ons with YOUR photo so you can see how each outfit looks on you.",
      icon: "🎨"
    },
    {
      title: "Auto-Updated Fashion Feed",
      description: "Set your preferences once - we'll keep your boutique fresh with new looks weekly, monthly, or whenever brands add new items.",
      icon: "🔄"
    },
    {
      title: "Multiple Boutiques",
      description: "Create separate boutiques for yourself, your spouse, kids, or anyone! Each with their own style, brands, and preferences.",
      icon: "👨‍👩‍👧‍👦"
    },
    {
      title: "Smart & Convenient",
      description: "See what's new without leaving home. Get notified when fresh looks are ready. Shop smarter with AI-powered virtual try-ons!",
      icon: "🛍️"
    }
  ];

  const handleNext = () => {
    if (currentCard < flashCards.length - 1) {
      setCurrentCard(currentCard + 1);
    } else {
      onComplete();
    }
  };

  const handlePrevious = () => {
    if (currentCard > 0) {
      setCurrentCard(currentCard - 1);
    }
  };

  const card = flashCards[currentCard];

  return (
    <div className="flash-cards-overlay">
      <div className="flash-cards-container">
        <div className="flash-card">
          <div className="card-icon">{card.icon}</div>
          <h2 className="card-title">{card.title}</h2>
          <p className="card-description">{card.description}</p>
          
          <div className="card-progress">
            {flashCards.map((_, index) => (
              <div
                key={index}
                className={`progress-dot ${index === currentCard ? 'active' : ''} ${index < currentCard ? 'completed' : ''}`}
              />
            ))}
          </div>

          <div className="card-actions">
            {currentCard > 0 && (
              <button className="btn-secondary" onClick={handlePrevious}>
                ← Previous
              </button>
            )}
            <button className="btn-primary" onClick={handleNext}>
              {currentCard < flashCards.length - 1 ? 'Next →' : 'Get Started! 🚀'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoutiqueFlashCards;
